module.exports = __webpack_public_path__ + "img/ic_income_verified.4aba7865.png";